/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
import { DialogPlugin } from './DialogPlugin';

export = DialogPlugin;
